module.exports = __webpack_public_path__ + "static/media/img44.89951da3.jpg";